import { useEffect } from "react";
import { api } from "@/lib/api";

export default function VisitorPing() {
  useEffect(() => {
    if (localStorage.getItem("tt_visited") || localStorage.getItem("tt_admin_token") || sessionStorage.getItem("tt_admin_token") || navigator.webdriver) return;
    let id = localStorage.getItem("tt_vid");
    if (!id) { id = crypto.randomUUID(); localStorage.setItem("tt_vid", id); }
    localStorage.setItem("tt_visited", "1");
    api.post("/visit", { visitor_id: id, path: window.location.pathname, referrer: document.referrer }).catch(() => {});
  }, []);
  return null;
}
